import { Box, Typography } from '@mui/material';
import { costSmallColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import BigNumber from 'bignumber.js';

type CostSmallDataType = {
  small_win_amount: string;
  name: string;
};

type CostSmallAmountType = {
  data: CostSmallDataType[];
  totalCostSmalAmount: string;
};

export default function CostSmall({ datas }: { datas: CostSmallAmountType }) {
  if (!datas || !datas.data || datas.data.length === 0) {
    return null;
  }

  // 총합 계산 (totalCostSmalAmount 사용 또는 직접 계산)
  let total = BigNumber(0);
  const list = datas.data.map((data) => {
    const amount = BigNumber(data.small_win_amount || '0');
    total = total.plus(amount);
    return {
      name: data.name,
      value: packBigNumbers(data.small_win_amount),
    };
  });

  // totalCostSmalAmount가 있으면 사용, 없으면 계산된 값 사용
  const displayTotal = datas.totalCostSmalAmount
    ? packBigNumbers(datas.totalCostSmalAmount)
    : packBigNumbers(total.toString());

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        소액 베팅 충당 비용 {displayTotal}
      </Typography>
      <Box sx={{ width: '100%' }}>
        {list && <Tables list={list} columns={costSmallColumns} getRowId={(row) => row.name} />}
      </Box>
    </Box>
  );
}
